import { atom } from 'recoil';

export const ShowLinkState = atom({
    key: 'ShowLinkState',
    default: {
        show: false,
        subTitle: ''
    }
});